export const openCloseStatusLoginAction = state => {
    return {
        type: "STATE_STATUS_LOGIN",
        payload: state
    };
};